import { useTranslation } from '../../i18n/i18n';
import { company, Icon, person } from '../Icon/Icon';
import { RadioButton } from './RadioButton';

export interface CustomerTypeModel {
	customerType: 'company' | 'private' | '';
}

type CustomerTypeInputProps = {
	model: CustomerTypeModel;
	onChange: (model: CustomerTypeModel) => void;
};
export const CustomerTypeInput = ({ model, onChange }: CustomerTypeInputProps): JSX.Element => {
	const t = useTranslation().form;

	return (
		<>
			<RadioButton
				checked={model.customerType === 'company'}
				group="customer_type"
				value="company"
				onChange={() => onChange({ customerType: 'company' })}
			>
				<Icon shape={company} />
				<span className="ml-2">{t.company}</span>
			</RadioButton>

			<RadioButton
				checked={model.customerType === 'private'}
				group="customer_type"
				value="private"
				onChange={() => onChange({ customerType: 'private' })}
			>
				<Icon shape={person} />
				<span className="ml-2">{t.person}</span>
			</RadioButton>
		</>
	);
};
